import React from "react";
import Card from "../card/Card";
import "./CardList.css";

const CardList = ({ cards, showNoResults, onCardClick }) => {
  if (showNoResults) {
    return <p>No cards found for that search.</p>;
  }

  return (
    <div className="card-list">
      {cards.map((card, index) => (
        <Card
          key={card.id}
          card={card}
          onCardClick={onCardClick}
          animationDelay={index * 50}
        />
      ))}
    </div>
  );
};

export default CardList;
